<template lang="pug">
	#account
		.tile.user-settings
			h4.line-head Account

			ValidationObserver(ref='Validator')
				form(@submit.prevent='onSubmit')
					.row.mb-4
						.col-md-8
							b Username
							p.form-control-static.m-0 {{info.email}}
					
					.row.mb-4
						.col-md-8
							b New Password
							ValidationProvider(name="password" v-slot='{errors}' rules='required|min:8|alpha_num_specialcase' v-bind:customMessages='{min: "Password must be not less than 8 of length"}')
								input.form-control(type='password' placeholder='New Password' v-model='form.new_pass')
								small.text-danger(v-for='error in errors') {{error}}
					
					.row.mb-4
						.col-md-8
							b Confirm Password
							ValidationProvider(name='confirm password' v-slot='{errors}' v-bind:rules='`required|is:${form.new_pass}`' v-bind:customMessages='{is: "Password mismatch"}')
								input.form-control(type='password' placeholder='Confirm Password' v-model='form.confirm_pass')
								small.text-danger(v-for='error in errors') {{error}}

					.row.mb-4
						.col-md-8.pt-3.broder-top
							button.btn.btn-primary(type='submit') Update Password

</template>

<script>
import {mapGetters} from 'vuex'
import Helper from 'src/helpers'

const form={
	new_pass:'',
	confirm_pass:''
}
export default {

  name: 'account',

  computed: {
  	...mapGetters('auth', {
			info: 'user'
		})
  },

  data () {
    return {
    	form: form
    }
  },

  methods:{
  	onSubmit() {
  		this.$refs.Validator.validate()
  			.then(success => {
  				if(!success) {
  					return false
  				}

  				this.$swal({
  					title: 'Enter current password',
  					input: 'password',
  					showCancelButton: true,
  					confirmButtonText: 'Proceed!'
  				}).then(result => {
  					// console.log(result)
  					if(result.isConfirmed) {
  						this.$swal({
  							text: 'Validating password. . .',
  							allowOutsideClick: false
  						})
  						this.$swal.showLoading()

  						this.$http.put('user/update-password', Object.assign({},this.form, {current_pass: result.value}))
  							.then(response=> {
  								this.form={
                    new_pass: '',
                    confirm_pass: ''
                  }
                  Helper.Swal.Success('Your password was successfully updated', 'Password Changed!')
  							})
  							.catch(response => {
  								Helper.Swal.Error(response)
  							})
  					}
  				})
  			})
  	}
  }
}
</script>

<style lang="css" scoped>
</style>